var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["product/templates/product-move-to-cart.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "<button type=\"button\" class=\"o-button-basket c-product-move-to-cart__button js-move-to-cart\" aria-controls=\"a-move-to-cart-confirm\" data-qa-move-to-cart>\n\n    <span class=\"c-product-move-to-cart__text js-update-item-text\">";
output += runtime.suppressValue((lineno = 2, colno = 69, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["product_move-to-cart"])), env.opts.autoescape);
output += "</span>\n\n</button>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["product/templates/product-move-to-cart.j2"] , dependencies)